(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lca-pdp-mobile-fixes"] && !Shopify.designMode) return;
  try {
    (() => {
  let observer;
  let attributes;
  function setup() {
    observer?.disconnect();
    attributes?.disconnect();
    const content = document.getElementById('lca-pdp-content');
    if (!content) return;
    const bar = content.querySelector('[data-pdp-sticky]');
    const measure = () => {
      const height = bar && !bar.hidden ? Math.ceil(bar.getBoundingClientRect().height) : 0;
      document.body.style.setProperty('--lca-pdp-sticky-height', `${height}px`);
    };
    if (bar) {
      observer = new ResizeObserver(measure);
      observer.observe(bar);
      attributes = new MutationObserver(measure);
      attributes.observe(bar, {attributes:true, attributeFilter:['hidden']});
    }
    measure();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup, {once:true});
  else setup();
  document.addEventListener('shopify:section:load', setup);
  document.addEventListener('shopify:section:unload', () => requestAnimationFrame(setup));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lca-product-cross-sells"] && !Shopify.designMode) return;
  try {
    (() => {
  function setup(root) {
    root.querySelectorAll('[data-pdp-recommendations]').forEach(panel => {
      if (panel.dataset.ready === 'true') return;

      const track = panel.querySelector('[data-recommendation-track]');
      const dotsContainer = panel.querySelector('[data-recommendation-dots]');

      if (!track) return;

      const originalCards = [
        ...track.querySelectorAll('[data-recommendation-card]')
      ];

      if (!originalCards.length) return;

      panel.dataset.ready = 'true';

      const cardsPerPage = 2;
      const pages = Math.ceil(originalCards.length / cardsPerPage);

      let currentPage = 0;
      let autoplayTimer = null;
      let restartTimer = null;

      /*
       * ------------------------------------------------------------
       * CREATE PAGE WRAPPERS
       * ------------------------------------------------------------
       *
       * Instead of relying on scrollLeft, every 2 products
       * are placed inside one full-width page.
       */
      track.innerHTML = '';

      const pageElements = [];

      for (let i = 0; i < originalCards.length; i += cardsPerPage) {
        const page = document.createElement('div');

        page.className = 'pdp-recommendation-page';

        const pageCards = originalCards.slice(
          i,
          i + cardsPerPage
        );

        pageCards.forEach(card => {
          page.appendChild(card);
        });

        track.appendChild(page);
        pageElements.push(page);
      }

      /*
       * ------------------------------------------------------------
       * CREATE DOTS
       * ------------------------------------------------------------
       */
      if (dotsContainer) {
        dotsContainer.innerHTML = '';

        if (pages > 1) {
          for (let index = 0; index < pages; index++) {
            const dot = document.createElement('button');

            dot.type = 'button';

            dot.className = 'pdp-recommendation-dot';

            dot.dataset.recommendationDot = index;

            dot.setAttribute(
              'aria-label',
              `Go to recommendation page ${index + 1}`
            );

            /*
             * Prevent any parent form behaviour.
             */
            dot.addEventListener('click', event => {
              event.preventDefault();
              event.stopPropagation();

              goToPage(index);
              restartAutoplay();
            });

            dotsContainer.appendChild(dot);
          }
        }
      }

      const dots = dotsContainer
        ? [
            ...dotsContainer.querySelectorAll(
              '[data-recommendation-dot]'
            )
          ]
        : [];

      /*
       * ------------------------------------------------------------
       * DOT STATE
       * ------------------------------------------------------------
       */
      function updateDots() {
        dots.forEach((dot, index) => {
          const active = index === currentPage;

          dot.classList.toggle('is-active', active);

          if (active) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });
      }

      /*
       * ------------------------------------------------------------
       * MOVE TO PAGE
       * ------------------------------------------------------------
       */
      function goToPage(page, animate = true) {
        if (pages <= 1) {
          currentPage = 0;
          return;
        }

        /*
         * IMPORTANT:
         *
         * We intentionally wrap here.
         *
         * Last page -> First page
         * First page -> Last page
         */
        currentPage =
          ((page % pages) + pages) % pages;

        track.style.transition = animate
          ? 'transform 450ms ease'
          : 'none';

        track.style.transform =
          `translate3d(-${currentPage * 100}%, 0, 0)`;

        updateDots();
      }

      /*
       * ------------------------------------------------------------
       * NEXT PAGE
       * ------------------------------------------------------------
       */
      function nextPage() {
        if (pages <= 1) return;

        goToPage(currentPage + 1);
      }

      /*
       * ------------------------------------------------------------
       * AUTOPLAY
       * ------------------------------------------------------------
       */
      function startAutoplay() {
        if (pages <= 1) return;

        stopAutoplay();

        autoplayTimer = setInterval(() => {
          nextPage();
        }, 3500);
      }

      function stopAutoplay() {
        if (autoplayTimer) {
          clearInterval(autoplayTimer);
          autoplayTimer = null;
        }
      }

      function restartAutoplay() {
        clearTimeout(restartTimer);

        stopAutoplay();

        restartTimer = setTimeout(() => {
          startAutoplay();
        }, 100);
      }

      /*
       * ------------------------------------------------------------
       * TOUCH SWIPE
       * ------------------------------------------------------------
       */
      let touchStartX = 0;
      let touchStartY = 0;
      let touching = false;

      track.addEventListener(
        'touchstart',
        event => {
          if (!event.touches.length) return;

          touching = true;

          touchStartX = event.touches[0].clientX;
          touchStartY = event.touches[0].clientY;

          stopAutoplay();
        },
        { passive: true }
      );

      track.addEventListener(
        'touchend',
        event => {
          if (!touching) return;

          touching = false;

          if (!event.changedTouches.length) {
            startAutoplay();
            return;
          }

          const touchEndX =
            event.changedTouches[0].clientX;

          const touchEndY =
            event.changedTouches[0].clientY;

          const deltaX = touchEndX - touchStartX;
          const deltaY = touchEndY - touchStartY;

          /*
           * Only treat it as a swipe if horizontal movement
           * is greater than vertical movement.
           */
          if (
            Math.abs(deltaX) > 40 &&
            Math.abs(deltaX) > Math.abs(deltaY)
          ) {
            if (deltaX < 0) {
              nextPage();
            } else {
              goToPage(currentPage - 1);
            }
          }

          restartAutoplay();
        },
        { passive: true }
      );

      /*
       * ------------------------------------------------------------
       * MOUSE DRAG SUPPORT
       * ------------------------------------------------------------
       */
      let mouseStartX = 0;
      let mouseDragging = false;

      track.addEventListener('mousedown', event => {
        mouseDragging = true;
        mouseStartX = event.clientX;

        stopAutoplay();
      });

      track.addEventListener('mouseup', event => {
        if (!mouseDragging) return;

        mouseDragging = false;

        const deltaX = event.clientX - mouseStartX;

        if (Math.abs(deltaX) > 40) {
          if (deltaX < 0) {
            nextPage();
          } else {
            goToPage(currentPage - 1);
          }
        }

        restartAutoplay();
      });

      track.addEventListener('mouseleave', () => {
        if (!mouseDragging) return;

        mouseDragging = false;
        restartAutoplay();
      });

      /*
       * ------------------------------------------------------------
       * KEYBOARD
       * ------------------------------------------------------------
       */
      track.setAttribute('tabindex', '0');

      track.addEventListener('keydown', event => {
        if (event.key === 'ArrowRight') {
          event.preventDefault();

          nextPage();
          restartAutoplay();
        }

        if (event.key === 'ArrowLeft') {
          event.preventDefault();

          goToPage(currentPage - 1);
          restartAutoplay();
        }
      });

      /*
       * ------------------------------------------------------------
       * PAUSE ON HOVER
       * ------------------------------------------------------------
       */
  
      /*
       * ------------------------------------------------------------
       * INITIAL STATE
       * ------------------------------------------------------------
       */
      goToPage(0, false);

      /*
       * Start automatic carousel.
       */
      startAutoplay();
    });
  }

  setup(document);

  document.addEventListener(
    'shopify:section:load',
    event => {
      setup(event.target);
    }
  );
})();
  } catch(e) { console.error(e); }
})();

})();
